<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ show_name( title_user ) }}
          <b class="caret"></b>
        </span>
        <span v-if="false">
          {{ show_name( title_user ) }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#!">
                  <i class="material-icons">notifications</i>
                  <span class="sidebar-normal">Notificações</span>
                </a>
              </li>
              <li v-if="url_sistema_antigo != null && url_sistema_antigo != undefined ">
                <a v-bind:href="url_sistema_antigo" target="_blank">
                  <i class="material-icons">chrome_reader_mode</i>
                  <span class="sidebar-normal">SOC V1</span>
                </a>
              </li>
              <li>
                <sidebar-item
                  :link="{path: '/operacional/configuracao', name: 'Configuração', icon: 'perm_data_setting'}"
                ></sidebar-item>
              </li>
              <li>
                <a href="#" v-on:click="sair">
                  <i class="material-icons">exit_to_app</i>
                  <span class="sidebar-normal">Sair</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import mixinuser from "../../../../library/mixin/user.js";
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    CollapseTransition
  },
  mixins: [mixinuser],
  props: {
    title: {
      type: String,
      default: "Nome do Usuário"
    },
    rtlTitle: {
      type: String,
      default: "Nome do Usuário"
    }
  },
  data() {
    return {
      isClosed: true,
      title_user: "",
      avatar: "./img/default-avatar.png",
      url_sistema_antigo: null
    };
  },
  mounted() {
    var user = this.getGlobalUser();
    this.title_user = user.nome;
    //console.log("User logado? ", user);

    if (user.url_sistema_antigo != null) {
      this.url_sistema_antigo = user.url_sistema_antigo;
    }

    if (
      user.cliente != null &&
      user.cliente != undefined &&
      user.cliente.logo != null &&
      user.cliente.logo != ""
    ) {
      this.avatar = user.cliente.logo;
    }
  },
  methods: {
    show_name: function(name) {
      var tam = name.length;

      if (tam > 20) {
        //Desenvolvimento
        return name.toString().substring(0, 20) + "";
      }

      return name;
    },
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    sair(event) {
      console.log("chamei o sair?");
      console.log(event);

      if (event != null) {
        this.removeGlobalUser();

        this.$router.push({ path: "/login?out=1" });
      }
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
